<template>
  <v-container>
    <!-- Add IP Dialog -->
    <v-dialog
      v-model="addIpDialogState"
      persistent
      width="300"
      retain-focus
      @keydown.esc="updateDialogState"
    >
      <!-- snackbar -->
      <SnackbarNew
        :snackbar.sync="snackbar"
        :snackbarError="snackbarError"
        :snackbarMessage="snackbarMessage"
      />
      <v-card>
        <!-- Title bar -->
        <v-card-title
          class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <div class="d-flex justify-center" style="width: 90%">
            <span>
              <b class="modals-title-size"> Add New IP Address </b>
            </span>
          </div>

          <v-spacer></v-spacer>
          <v-icon small color="#757096" @click="updateDialogState"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="mt-5">
          <v-form>
            <v-text-field
              label="Label"
              required
              autocomplete="off"
              color="#2a206a"
              dense
              outlined
              @keydown.enter="$refs.ip_address.focus()"
              v-model="ipObj.ip_label"
              autofocus
            ></v-text-field>

            <v-text-field
              label="IP Address"
              autocomplete="off"
              color="#2a206a"
              dense
              ref="ip_address"
              outlined
              @keydown.enter="ValidateIPaddress()"
              hint="example : 192.168.0.1"
              v-model="ipObj.ip_address"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color=" darken-1" text @click="updateDialogState">
            Close
          </v-btn>
          <v-btn
            :loading="loader"
            class="white--text btn-success text-capitalize"
            color="darken-1"
            text
            tile
            type="submit"
            @click="ValidateIPaddress()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { snackbarMixin } from "@/mixins/snackbarMixin";
export default {
  data() {
    return {
      addIpDialogState: false,
      ipObj: { ip_address: "", ip_label: "" },
      loader: false,
    };
  },
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  props: {
    addIpDialogProp: {
      type: Boolean,
    },
  },
  mixins: [snackbarMixin],
  methods: {
    updateDialogState() {
      this.addIpDialogState = false;
      this.ipObj = {};
      this.ip_data = [];
      this.$emit("update:addIpDialogProp", this.addIpDialogState);
    },
    // Validating IP Address added by the user.
    ValidateIPaddress() {
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          this.ipObj.ip_address
        )
      ) {
        this.addNewIp();
      } else {
        this.ipObj.ip_address = "";
        this.openSnackbar(true, "You have entered an invalid IP address!");
        return;
      }
    },
    addNewIp() {
      this.loader = true;
      this.$store
        .dispatch("createIP", this.ipObj)
        .then((response) => {
          this.loader = false;
          this.updateDialogState();
          this.$emit("showSnackbar", {
            message: "IP Address Added Successfully",
            error: false,
          });
          this.openSnackbar(false, response.data.error_msg);
        })
        .catch((error) => {
          this.loader = false;
          if (error.response.status == 422) {
            if (error.response.data.errors.ip_label) {
              this.openSnackbar(true, error.response.data.errors.ip_label[0]);
            } else if (error.response.data.errors.error) {
              this.openSnackbar(true, error.response.data.errors.error[0]);
            }
          }
        });
    },
  },
  watch: {
    addIpDialogProp: function() {
      this.addIpDialogState = this.addIpDialogProp;
    },
  },
};
</script>
